/* @flow weak */
import { ActionTypes as ExternalAccountResourceActionTypes } from '../constants/ExternalAccountResourceConstants';
import ExternalAccountResources from 'collections/ExternalAccountResources';

export type State = {
  externalAccountResources: ExternalAccountResources,
};

export const initialState: State = {
  externalAccountResources: new ExternalAccountResources(),
};

export function reducer(state = initialState, action) {
  let externalAccountResources;
  let resourceToRemove;

  switch (action.type) {
    case ExternalAccountResourceActionTypes.DELETE_BANK_ACCOUNT:
      externalAccountResources = state.externalAccountResources.clone();
      resourceToRemove = externalAccountResources.find(ea => ea.getBankAccount().id === action.bankAccount.id);
      externalAccountResources.remove(resourceToRemove);
      return { ...state, externalAccountResources };

    case ExternalAccountResourceActionTypes.UPDATE_PRIMARY_BANK_ACCOUNT:
      externalAccountResources = state.externalAccountResources.clone();
      externalAccountResources.forEach(ea => {
        const bankAccount = ea.getBankAccount();
        if (bankAccount.id === action.bankAccount.id) {
          bankAccount.setDefaultForCurrency(true);
        } else {
          bankAccount.setDefaultForCurrency(false);
        }
      });
      return { ...state, externalAccountResources };

    case ExternalAccountResourceActionTypes.CREATE_BANK_ACCOUNT:
      externalAccountResources = state.externalAccountResources.clone();
      externalAccountResources.add(action.externalAccountResource);
      return { ...state, externalAccountResources };

    case ExternalAccountResourceActionTypes.LOAD_BANK_ACCOUNTS:
      externalAccountResources = action.externalAccountResources;
      return { ...state, externalAccountResources };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/payments/reducers/ExternalAccountResource.js